import React, { ReactElement, useEffect, useState } from 'react';
import { changeLanguage, t } from 'i18next';
import { useSearchParams } from 'react-router-dom';
import { Market } from '@oneaudi/avp-models';
import styled from 'styled-components';
import { Locale } from '@oneaudi/avp-hck-dga-customerui-commons';
import { CupraHeader, CupraLogo, StyledApp, StyledView } from '../giveaway/Giveaway';
import { ErrorSite } from '../../components/errorSite/ErrorSite';
import { Footer } from '../../components/footer/Footer';
import logo from '../../assets/logo.png';

const Container = styled.div`
  display: block;
  margin-top: 80px;
  padding: 15px;

  p {
    margin-top: 5px;
    margin-bottom: 5px;
  }

  pre {
    margin-top: 30px;
    white-space: pre-wrap;
  }
`;

export const ThirdPartySoftware = (): ReactElement => {
  const [isResponseStatus, setResponseStatus] = useState(200);
  const [licenses, setLicenses] = useState<string>();
  const [searchParams] = useSearchParams();
  const locale = (searchParams.get('locale') as Locale) ?? Locale.en;
  const market = (searchParams.get('market') as Market) ?? Market.DEU;

  useEffect(() => {
    changeLanguage(locale);
  }, [locale]);

  useEffect(() => {
    fetch('/licenses.txt')
      .then((file) => file.text())
      .then((text) => setLicenses(text));
  });

  if (isResponseStatus !== 200) {
    return <ErrorSite locale={locale} errorKey="temporalError" />;
  }

  return (
    <StyledView>
      <StyledApp>
        <CupraHeader>
          <CupraLogo src={logo} alt="Cupra" />
        </CupraHeader>
        <Container>
          <h1>{t('thirdPartySoftware.title')}</h1>
          <p role="message">{t('thirdPartySoftware.message')}</p>
          <pre role="licenses-list">{licenses}</pre>
        </Container>
        <Footer locale={locale} market={market} disableThirdPartyLink onError={setResponseStatus} />
      </StyledApp>
    </StyledView>
  );
};
